import { UuidManager } from './uuid'

interface UserData {
  uuid: string
}

class User<T extends UserData = UserData> {
  private data: T
  private storage: Storage
  private storageKey: string
  public uuidManager: UuidManager

  constructor(storageKey = 'sso.user', storage = window.localStorage) {
    this.storageKey = storageKey
    this.storage = storage
    this.data = this.getData()

    this.uuidManager = new UuidManager(this.data.uuid)

    this.uuidManager.onChange((event: CustomEvent) => {
      this.set('uuid', event.detail as T[keyof T])
    })

    this.setUUID()
  }

  private setUUID() {
    this.set('uuid', this.uuidManager.get() as T[keyof T])
  }

  private getData(): T {
    try {
      const data = this.storage.getItem(this.storageKey)

      return data ? JSON.parse(data) : {}
    } catch (error) {
      console.error('[User][getData]', error)

      this.destroy()

      return {} as T
    }
  }

  private persist() {
    try {
      if (!this.data.uuid) this.setUUID()

      this.storage.setItem(this.storageKey, JSON.stringify(this.data))
    } catch (error) {
      console.error('[User][persist]', error)
    }
  }

  destroy() {
    this.data = {} as T
    this.storage.removeItem(this.storageKey)
  }

  get(key: keyof T) {
    return this.data[key]
  }

  set(key: keyof T, value: T[keyof T]) {
    this.data[key] = value
    this.persist()
  }

  unset(key: keyof T) {
    delete this.data[key]
    this.persist()
  }
}

const SSO_USER = new User()

globalThis.SSO_USER = SSO_USER

export { SSO_USER }